import { SET_AREA, SET_WIDTH, SET_LENGTH, SET_VOLUME, SET_APPLY_COMPRESSION, SET_DEPTH, SHOW_MORE_PRODUCT_INFO_POPUP } from "../Actions/QuantityCalculator.action";

const defaultState = {
    area: 0,
    width: 0,
    length: 0,
    volume: 0,
    depth: 0,
    applyCompression: false,
    showQuantityCalculatorMoreProductInfoPopUp: false
}

export const quantityCalculator = (state = defaultState, action) => {
    switch (action.type) {
        case SET_AREA:
        case SET_WIDTH:
        case SET_LENGTH:
        case SET_VOLUME:
        case SET_APPLY_COMPRESSION:
        case SET_DEPTH:
        case SHOW_MORE_PRODUCT_INFO_POPUP:
            return {
                ...state,
                ...action.payload
            }
        default:
            return state;
    }
}